var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_arrow_line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .arrow-line-class-a {\n        fill: none !important;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    className: "arrow-line-class-a",
    "data-name": "Rectangle 509",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M91.94,1198.026a.776.776,0,0,1,.414,0,.857.857,0,0,1,.639.937l-.019.1L88.565,1216.7a.782.782,0,0,1-.224.387.846.846,0,0,1-1.126.075l-.08-.075-6.01-6L74.207,1218,73,1216.785l6.917-6.911-6.01-6.012a.782.782,0,0,1-.225-.387.861.861,0,0,1,.526-1.012l.1-.025Zm-.966,2-14.794,3.7,11.1,11.1Z",
    transform: "translate(-67 -1191.998)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_arrow_line.f7863e77ecefd1a47876e7b0d44ac62e.svg";